export const FIND_OR_CREATE_REQUESTED = 'find_or_create_requested';
export const FIND_OR_CREATE_SUCCESS = 'find_or_create_success';
export const FIND_OR_CREATE_FAILURE = 'find_or_create_failure';

export const STORE_FIND_OR_CREATE_REQUESTED = 'store_find_or_create_requested';
export const STORE_FIND_OR_CREATE_SUCCESS = 'store_find_or_create_success';
export const STORE_FIND_OR_CREATE_FAILURE = 'store_find_or_create_failure';

export const STORE_SETTINGS_FIND_REQUESTED = 'store_settings_find_requested';
export const STORE_SETTINGS_FIND_SUCCESS = 'store_settings_find_success';
export const STORE_SETTINGS_FIND_FAILURE = 'store_settings_find_failure';

export const USER_FIND_OR_CREATE_REQUESTED = 'user_find_or_create_requested';
export const USER_FIND_OR_CREATE_SUCCESS = 'user_find_or_create_success';
export const USER_FIND_OR_CREATE_FAILURE = 'user_find_or_create_failure';

export const LOCATIONS_INDEX_REQUESTED = 'locations_index_requested';
export const LOCATIONS_INDEX_SUCCESS = 'locations_index_success';
export const LOCATIONS_INDEX_FAILURE = 'locations_index_failure';

export const CORPORATE_LOCATION_CREATE_REQUESTED = 'corporate_location_create_requested';
export const CORPORATE_LOCATION_CREATE_SUCCESS = 'corporate_location_create_success';
export const CORPORATE_LOCATION_CREATE_FAILURE = 'corporate_location_create_failure';

export const CORPORATE_LOCATION_UPDATE_REQUESTED = 'corporate_location_update_requested';
export const CORPORATE_LOCATION_UPDATE_SUCCESS = 'corporate_location_update_success';
export const CORPORATE_LOCATION_UPDATE_FAILURE = 'corporate_location_update_failure';

export const CORPORATE_LOCATION_DELETE_REQUESTED = 'corporate_location_delete_requested';
export const CORPORATE_LOCATION_DELETE_SUCCESS = 'corporate_location_delete_success';
export const CORPORATE_LOCATION_DELETE_FAILURE = 'corporate_location_delete_failure';

export const PAYMENT_REQUESTED = 'payment_requested';
export const PAYMENT_SUCCESS = 'payment_success';
export const PAYMENT_FAILURE = 'payment_failure';

export const PAYMENT_SESSION_REQUESTED = 'payment_session_requested';
export const PAYMENT_SESSION_SUCCESS = 'payment_session_success';
export const PAYMENT_SESSION_FAILURE = 'payment_session_failure';

export const PAYMENT_VERIFICATION_REQUESTED = 'payment_verification_requested';
export const PAYMENT_VERIFICATION_SUCCESS = 'payment_verification_success';
export const PAYMENT_VERIFICATION_FAILURE = 'payment_verification_failure';

export const SUPPLIERS_INDEX_REQUESTED = 'suppliers_index_requested';
export const SUPPLIERS_INDEX_SUCCESS = 'suppliers_index_success';
export const SUPPLIERS_INDEX_FAILURE = 'suppliers_index_failure';

export const SUPPLIERS_CREATE_REQUESTED = 'suppliers_create_requested';
export const SUPPLIERS_CREATE_SUCCESS = 'suppliers_create_success';
export const SUPPLIERS_CREATE_FAILURE = 'suppliers_create_failure';

export const SUPPLIERS_UPDATE_REQUESTED = 'suppliers_update_requested';
export const SUPPLIERS_UPDATE_SUCCESS = 'suppliers_update_success';
export const SUPPLIERS_UPDATE_FAILURE = 'suppliers_update_failure';

export const SUPPLIERS_DELETE_REQUESTED = 'suppliers_delete_requested';
export const SUPPLIERS_DELETE_SUCCESS = 'suppliers_delete_success';
export const SUPPLIERS_DELETE_FAILURE = 'suppliers_delete_failure';

export const TAX_SETTINGS_INDEX_REQUESTED = 'tax_settings_index_requested';
export const TAX_SETTINGS_INDEX_SUCCESS = 'tax_settings_index_success';
export const TAX_SETTINGS_INDEX_FAILURE = 'tax_settings_index_failure';

export const PAYMENT_METHODS_INDEX_REQUESTED = 'payment_methods_index_requested';
export const PAYMENT_METHODS_INDEX_SUCCESS = 'payment_methods_index_success';
export const PAYMENT_METHODS_INDEX_FAILURE = 'payment_methods_index_failure';

export const PAYMENT_TERMS_INDEX_REQUESTED = 'payment_terms_index_requested';
export const PAYMENT_TERMS_INDEX_SUCCESS = 'payment_terms_index_success';
export const PAYMENT_TERMS_INDEX_FAILURE = 'payment_terms_index_failure';

export const ASSIGNMENTS_INDEX_REQUESTED = 'assignments_index_requested';
export const ASSIGNMENTS_INDEX_SUCCESS = 'assignments_index_success';
export const ASSIGNMENTS_INDEX_FAILURE = 'assignments_index_failure';

export const ASSIGNMENTS_CREATE_REQUESTED = 'assignments_create_requested';
export const ASSIGNMENTS_CREATE_SUCCESS = 'assignments_create_success';
export const ASSIGNMENTS_CREATE_FAILURE = 'assignments_create_failure';

export const ASSIGNMENTS_UPDATE_REQUESTED = 'assignments_update_requested';
export const ASSIGNMENTS_UPDATE_SUCCESS = 'assignments_update_success';
export const ASSIGNMENTS_UPDATE_FAILURE = 'assignments_update_failure';

export const ASSIGNMENTS_DELETE_REQUESTED = 'assignments_delete_requested';
export const ASSIGNMENTS_DELETE_SUCCESS = 'assignments_delete_success';
export const ASSIGNMENTS_DELETE_FAILURE = 'assignments_delete_failure';

export const ASSIGNMENTS_BY_ITEM_REQUESTED = 'assignments_by_item_requested';
export const ASSIGNMENTS_BY_ITEM_SUCCESS = 'assignments_by_item_success';

export const CATEGORIES_REQUESTED = 'categories_requested';
export const CATEGORIES_SUCCESS = 'categories_success';
export const CATEGORIES_FAILURE = 'categories_failure';

export const SEARCH_PRODUCT_REQUESTED = 'search_product_requested';
export const SEARCH_PRODUCT_SUCCESS = 'search_product_success';
export const SEARCH_PRODUCT_FAILURE = 'search_product_failure';

export const FIND_PRODUCT_INVENTORIES_REQUESTED = 'find_product_inventories_requested';
export const FIND_PRODUCT_INVENTORIES_SUCCESS = 'find_product_inventories_success';
export const FIND_PRODUCT_INVENTORIES_FAILURE = 'find_product_inventories_failure';

export const DELETE_PRODUCT_METAFIELD_REQUESTED = 'delete_product_metafield_success';
export const DELETE_PRODUCT_METAFIELD_SUCCESS = 'delete_product_metafield_failure';

export const SCAN_PRODUCT_REQUESTED = 'scan_product_requested';
export const SCAN_PRODUCT_SUCCESS = 'scan_product_success';
export const SCAN_PRODUCT_FAILURE = 'scan_product_failure';

export const UPDATE_SELECTED_ITEMS = 'update_selected_items';

export const PURCHASE_ORDERS_INDEX_REQUESTED = 'purchase_orders_index_requested';
export const PURCHASE_ORDERS_INDEX_SUCCESS = 'purchase_orders_index_success';
export const PURCHASE_ORDERS_INDEX_FAILURE = 'purchase_orders_index_failure';

export const PURCHASE_ORDER_FIND_REQUESTED = 'purchase_order_find_requested';
export const PURCHASE_ORDER_FIND_SUCCESS = 'purchase_order_find_success';
export const PURCHASE_ORDER_FIND_FAILURE = 'purchase_order_find_failure';

export const PURCHASE_ORDERS_CREATE_REQUESTED = 'purchase_orders_create_requested';
export const PURCHASE_ORDERS_CREATE_SUCCESS = 'purchase_orders_create_success';
export const PURCHASE_ORDERS_CREATE_FAILURE = 'purchase_orders_create_failure';

export const ADD_TO_PO = 'add_to_po';
export const UPDATE_EXTERNAL_PO_LINE = 'update_external_po_line';
export const REMOVE_FROM_PO = 'remove_from_po';
export const ADJUST_TOTAL = 'adjust_total';
export const ADJUST_TAX_PERCENT = 'adjust_tax_percent';
export const UPDATE_PO_QUANTITY = 'update_po_quantity';
export const OVERRIDE_UNIT_COST = 'override_unit_cost';
export const OVERRIDE_UNIT_TAX = 'override_unit_tax';

export const RECEIVING_ORDERS_INDEX_REQUESTED = 'receiving_orders_index_requested';
export const RECEIVING_ORDERS_INDEX_SUCCESS = 'receiving_orders_index_success';
export const RECEIVING_ORDERS_INDEX_FAILURE = 'receiving_orders_index_failure';

export const RECEIVING_ORDER_FIND_REQUESTED = 'receiving_order_find_requested';
export const RECEIVING_ORDER_FIND_SUCCESS = 'receiving_order_find_success';
export const RECEIVING_ORDER_FIND_FAILURE = 'receiving_order_find_failure';

export const RECEIVING_ORDER_CREATE_REQUESTED = 'receiving_order_create_requested';
export const RECEIVING_ORDER_CREATE_SUCCESS = 'receiving_order_create_success';
export const RECEIVING_ORDER_CREATE_FAILURE = 'receiving_order_create_failure';

export const PURCHASE_ORDERS_UPDATE_REQUESTED = 'purchase_orders_update_requested';
export const PURCHASE_ORDERS_UPDATE_SUCCESS = 'purchase_orders_update_success';
export const PURCHASE_ORDERS_UPDATE_FAILURE = 'purchase_orders_update_failure';


export const PURCHASE_ORDER_MARK_ISSUED_REQUESTED = 'purchase_order_mark_issued_requested';
export const PURCHASE_ORDER_MARK_ISSUED_SUCCESS = 'purchase_order_mark_issued_success';
export const PURCHASE_ORDER_MARK_ISSUED_FAILURE = 'purchase_order_mark_issued_failure';

export const PURCHASE_ORDER_MARK_FULFILLED_REQUESTED = 'purchase_order_mark_fulfilled_requested';
export const PURCHASE_ORDER_MARK_FULFILLED_SUCCESS = 'purchase_order_mark_fulfilled_success';
export const PURCHASE_ORDER_MARK_FULFILLED_FAILURE = 'purchase_order_mark_fulfilled_failure';

export const PURCHASE_ORDER_MARK_PAID_REQUESTED = 'purchase_order_mark_paid_requested';
export const PURCHASE_ORDER_MARK_PAID_SUCCESS = 'purchase_order_mark_paid_success';
export const PURCHASE_ORDER_MARK_PAID_FAILURE = 'purchase_order_mark_paid_failure';

export const PURCHASE_ORDER_MARK_CLOSED_REQUESTED = 'purchase_order_mark_closed_requested';
export const PURCHASE_ORDER_MARK_CLOSED_SUCCESS = 'purchase_order_mark_closed_success';
export const PURCHASE_ORDER_MARK_CLOSED_FAILURE = 'purchase_order_mark_closed_failure';


export const PURCHASE_ORDER_MARK_REJECTED_REQUESTED = 'purchase_order_mark_rejected_requested';
export const PURCHASE_ORDER_MARK_REJECTED_SUCCESS = 'purchase_order_mark_rejected_success';
export const PURCHASE_ORDER_MARK_REJECTED_FAILURE = 'purchase_order_mark_rejected_failure';

export const PURCHASE_ORDER_UPDATE_SHIPMENTS_REQUESTED = 'purchase_order_update_shipments_requested';
export const PURCHASE_ORDER_UPDATE_SHIPMENTS_SUCCESS = 'purchase_order_update_shipments_success';
export const PURCHASE_ORDER_UPDATE_SHIPMENTS_FAILURE = 'purchase_order_update_shipments_failure';

export const PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_REQUESTED = 'purchase_order_check_item_existence_requested';
export const PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_SUCCESS = 'purchase_order_check_item_existence_success';
export const PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_FAILURE = 'purchase_order_check_item_existence_failure';

export const PURCHASE_ORDER_DOWNLOAD_REQUESTED = 'purchase_order_download_requested';
export const PURCHASE_ORDER_DOWNLOAD_SUCCESS = 'purchase_order_download_success';
export const PURCHASE_ORDER_DOWNLOAD_FAILURE = 'purchase_order_download_failure';


export const SETTINGS_REQUESTED = 'settings_requested';
export const SETTINGS_SUCCESS = 'settings_success';
export const SETTINGS_FAILURE = 'settings_failure';

export const SETTINGS_UPDATE_REQUESTED = 'settings_update_requested';
export const SETTINGS_UPDATE_SUCCESS = 'settings_update_success';
export const SETTINGS_UPDATE_FAILURE = 'settings_update_failure';

export const UPLOAD_TOKEN_REQUESTED = 'upload_token_requested';
export const UPLOAD_TOKEN_SUCCESS = 'upload_token_success';

export const LOGO_UPLOAD_REQUESTED = 'logo_upload_requested';
export const LOGO_UPLOAD_SUCCESS = 'logo_upload_success';
export const LOGO_UPLOAD_FAILURE = 'logo_upload_failure';


export const PAYMENT_METHOD_CREATE_REQUESTED = 'payment_method_create_requested';
export const PAYMENT_METHOD_CREATE_SUCCESS = 'payment_method_create_success';
export const PAYMENT_METHOD_CREATE_FAILURE = 'payment_method_create_failure';

export const PAYMENT_METHOD_UPDATE_REQUESTED = 'payment_method_update_requested';
export const PAYMENT_METHOD_UPDATE_SUCCESS = 'payment_method_update_success';
export const PAYMENT_METHOD_UPDATE_FAILURE = 'payment_method_update_failure';

export const PAYMENT_METHOD_DELETE_REQUESTED = 'payment_method_delete_requested';
export const PAYMENT_METHOD_DELETE_SUCCESS = 'payment_method_delete_success';
export const PAYMENT_METHOD_DELETE_FAILURE = 'payment_method_delete_failure';

export const PAYMENT_TERM_CREATE_REQUESTED = 'payment_term_create_requested';
export const PAYMENT_TERM_CREATE_SUCCESS = 'payment_term_create_success';
export const PAYMENT_TERM_CREATE_FAILURE = 'payment_term_create_failure';

export const PAYMENT_TERM_UPDATE_REQUESTED = 'payment_term_update_requested';
export const PAYMENT_TERM_UPDATE_SUCCESS = 'payment_term_update_success';
export const PAYMENT_TERM_UPDATE_FAILURE = 'payment_term_update_failure';

export const PAYMENT_TERM_DELETE_REQUESTED = 'payment_term_delete_requested';
export const PAYMENT_TERM_DELETE_SUCCESS = 'payment_term_delete_success';
export const PAYMENT_TERM_DELETE_FAILURE = 'payment_term_delete_failure';

export const TAX_SETTING_CREATE_REQUESTED = 'tax_setting_create_requested';
export const TAX_SETTING_CREATE_SUCCESS = 'tax_setting_create_success';
export const TAX_SETTING_CREATE_FAILURE = 'tax_setting_create_failure';

export const TAX_SETTING_UPDATE_REQUESTED = 'tax_setting_update_requested';
export const TAX_SETTING_UPDATE_SUCCESS = 'tax_setting_update_success';
export const TAX_SETTING_UPDATE_FAILURE = 'tax_setting_update_failure';

export const TAX_SETTING_DELETE_REQUESTED = 'tax_setting_delete_requested';
export const TAX_SETTING_DELETE_SUCCESS = 'tax_setting_delete_success';
export const TAX_SETTING_DELETE_FAILURE = 'tax_setting_delete_failure';

export const ASSIGNMENTS_CSV_UPLOAD_REQUESTED = 'assignments_csv_upload_requested';
export const ASSIGNMENTS_CSV_UPLOAD_SUCCESS = 'assignments_csv_upload_success';
export const ASSIGNMENTS_CSV_UPLOAD_FAILURE = 'assignments_csv_upload_failure';

export const ASSIGNMENTS_CSV_PROCESS_REQUESTED = 'assignments_csv_process_requested';
export const ASSIGNMENTS_CSV_PROCESS_SUCCESS = 'assignments_csv_process_success';
export const ASSIGNMENTS_CSV_PROCESS_FAILURE = 'assignments_csv_process_failure';

export const ASSIGNMENT_CREATE_REQUESTED = 'assignment_create_requested';
export const ASSIGNMENT_CREATE_SUCCESS = 'assignment_create_success';
export const ASSIGNMENT_CREATE_FAILURE = 'assignment_create_failure';

export const RESET_PO_LINES = 'reset_po_lines';
export const RESET_ASSIGNMENTS_STATE = 'reset_assignments_state';

export const RESET_PURCHASE_ORDER_STATE = 'reset_purchase_order_state';
export const RESET_PRODUCTS_STATE = 'reset_products_state';
export const RESET_NEW_PO = 'reset_new_po';
export const CLEAR_NEW_SUPPLIER = 'clear_new_supplier';

export const INCOMPLETE_ORDERS_REQUESTED = 'incomplete_orders_requested';
export const INCOMPLETE_ORDERS_SUCCESS = 'incomplete_orders_success';
export const INCOMPLETE_ORDERS_FAILURE = 'incomplete_orders_failure';

export const ORDER_SHIPMENTS_REQUESTED = 'order_shipments_requested';
export const ORDER_SHIPMENTS_SUCCESS = 'order_shipments_success';
export const ORDER_SHIPMENTS_FAILURE = 'order_shipments_failure';

export const ORDER_WITH_SHIPMENTS_REQUESTED = 'order_with_shipments_requested';
export const ORDER_WITH_SHIPMENTS_SUCCESS = 'order_with_shipments_success';

export const THRESHOLDS_INDEX_REQUESTED = 'thresholds_index_requested';
export const THRESHOLDS_INDEX_SUCCESS = 'thresholds_index_success';
export const THRESHOLDS_INDEX_FAILURE = 'thresholds_index_failure';

export const THRESHOLDS_CREATE_REQUESTED = 'thresholds_create_requested';
export const THRESHOLDS_CREATE_SUCCESS = 'thresholds_create_success';
export const THRESHOLDS_CREATE_FAILURE = 'thresholds_create_failure';

export const THRESHOLDS_BY_ITEM_REQUESTED = 'thresholds_by_item_requested';
export const THRESHOLDS_BY_ITEM_SUCCESS = 'thresholds_by_item_success';

export const THRESHOLDS_UPDATE_REQUESTED = 'thresholds_update_requested';
export const THRESHOLDS_UPDATE_SUCCESS = 'thresholds_update_success';
export const THRESHOLDS_UPDATE_FAILURE = 'thresholds_update_failure';

export const THRESHOLDS_DELETE_REQUESTED = 'thresholds_delete_requested';
export const THRESHOLDS_DELETE_SUCCESS = 'thresholds_delete_success';
export const THRESHOLDS_DELETE_FAILURE = 'thresholds_delete_failure';

export const THRESHOLDS_CSV_UPLOAD_REQUESTED = 'thresholds_csv_upload_requested';
export const THRESHOLDS_CSV_UPLOAD_SUCCESS = 'thresholds_csv_upload_success';
export const THRESHOLDS_CSV_UPLOAD_FAILURE = 'thresholds_csv_upload_failure';

export const THRESHOLDS_CSV_PROCESS_REQUESTED = 'thresholds_csv_process_requested';
export const THRESHOLDS_CSV_PROCESS_SUCCESS = 'thresholds_csv_process_success';
export const THRESHOLDS_CSV_PROCESS_FAILURE = 'thresholds_csv_process_failure';

export const RESET_THRESHOLDS_STATE = 'reset_thresholds_state';

export const SUGGESTED_PURCHASE_ORDER_INDEX_REQUESTED = 'suggested_purchase_order_index_requested';
export const SUGGESTED_PURCHASE_ORDER_INDEX_SUCCESS = 'suggested_purchase_order_index_success';
export const SUGGESTED_PURCHASE_ORDER_INDEX_FAILURE = 'suggested_purchase_order_index_failure';

export const SUGGESTED_PURCHASE_ORDER_FIND_REQUESTED = 'suggested_purchase_order_find_requested';
export const SUGGESTED_PURCHASE_ORDER_FIND_SUCCESS = 'suggested_purchase_order_find_success';
export const SUGGESTED_PURCHASE_ORDER_FIND_FAILURE = 'suggested_purchase_order_find_failure';

export const SUGGESTED_PURCHASE_ORDER_CREATE_REQUESTED = 'suggested_purchase_order_create_requested';
export const SUGGESTED_PURCHASE_ORDER_CREATE_SUCCESS = 'suggested_purchase_order_create_success';
export const SUGGESTED_PURCHASE_ORDER_CREATE_FAILURE = 'suggested_purchase_order_create_failure';

export const SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_REQUESTED = 'suggested_purchase_order_mark_complete_requested';
export const SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_SUCCESS = 'suggested_purchase_order_mark_complete_success';
export const SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_FAILURE = 'suggested_purchase_order_mark_complete_failure';

export const GET_ASSIGNMENT_THRESHOLDS_REQUESTED = 'get_assignment_thresholds_requested';
export const GET_ASSIGNMENT_THRESHOLDS_SUCCESS = 'get_assignment_thresholds_success';
export const GET_ASSIGNMENT_THRESHOLDS_FAILURE = 'get_assignment_thresholds_failure';

// export const _REQUESTED = '_requested';
// export const _SUCCESS = '_success';
// export const _FAILURE = '_failure';
